import { useEffect, useState } from 'react';

export function toFrameBucket(seconds: number): number {
  return Math.floor(seconds + 0.4);
}

export function useVideoCurrentTime(
  videoRef?: React.RefObject<HTMLVideoElement>
) {
  const [currentSecond, setCurrentSecond] = useState<number>(0);

  useEffect(() => {
    const video = videoRef?.current;
    if (!video) return;

    const handleTimeUpdate = () => {
      const sec = toFrameBucket(video.currentTime);
      setCurrentSecond((prev) => (prev !== sec ? sec : prev));
    };

    video.addEventListener('timeupdate', handleTimeUpdate);
    video.addEventListener('seeked', handleTimeUpdate);
    return () => {
      video.removeEventListener('timeupdate', handleTimeUpdate);
      video.removeEventListener('seeked', handleTimeUpdate);
    };
  }, [videoRef]);

  return currentSecond;
}
